(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
(function () {
    var root = document.querySelector('[data-u-root="ostatnie-losowanie"]');
    var dane = document.querySelector('script[type="application/json"][data-page-report]');
    if (!root || !dane) return;
    root.dataset.gra = __pewniaki_inline_cfg[0];
    var raport;
    try { raport = JSON.parse(dane.textContent); } catch (e) { raport = null; }
    var ui = window.PEWNIAKI_UI_OSTATNIE;
    if (ui && typeof ui.render === 'function') { ui.render(root, raport, 10); }
})();
})();
